import {Menu, Transition} from '@headlessui/react';
import React, {Fragment, ReactElement, isValidElement} from 'react';
import DropdownItem, {DropdownItemProps} from "./DropdownItem";
import DropdownButton from "./DropdownButton";
import {concatenate} from "../../services/string";

// Types ----

export type Option = DropdownItemProps

type DropdownProps = {
  options?: Array<Option>
  children?: Array<Option | ReactElement | false | null>
  hideIfEmpty?: boolean
  position?: 'left' | 'right'
}

// Helpers ----

function isOption(option: Option | ReactElement | false | null): option is Option {
  return (option as Option).onClick !== undefined || (option as Option).download !== undefined;
}

// Component ----

function Dropdown({options: items, children, hideIfEmpty, position = 'right'}: DropdownProps) {
  const options = (items ?? children ?? []).filter(Boolean);

  if(options.length < 1 && !!hideIfEmpty) {
    return null;
  }

  return (
    <Menu as="div" className="inline-block text-left">

      {/* Trigger button */}
      <DropdownButton/>

      {/* Menu body */}
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          className={concatenate(
            position === 'left' ? 'left-2' : 'right-2',
            "origin-top-right absolute mt-2 w-56 z-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
          )}>
          <div className="py-1">
            {options.map(option => {

              if (isValidElement<typeof DropdownItem>(option)) {
                return option;
              }

              if (isOption(option)) {
                return <DropdownItem key={option.name} {...option}/>
              }

              return null;
            })}
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default Dropdown;